<template lang="pug">
k-main.admin-dashboard
  template( #title )
    .title
      h1.title Dashboard
      k-actions.header-actions( :actions='actions' :icons='icons' )
  .main-content( v-if='post.sections' v-bar )
    .inner
      k-objects(
        v-for='section in sections'
        :key='section.name'
        v-bind='section'
        :icons='icons'        
      )
  k-objects.main-content( v-else v-bind='post' :icons='icons' innline )
  k-actions.footer-actions(
    :actions='actions'
    :icons='icons'
    type='icon-text'
  )
</template>

<script lang="js">
import { mapState, mapActions } from 'vuex'
import KActions from '@/blocks/k-actions'
import KMain from '@/blocks/k-main'
import KObjects from '@/blocks/k-objects'
import ILock from 'icons/Lock'
import IChevronUp from 'icons/ChevronUp'
import IChevronRight from 'icons/ChevronRight'
import IChevronDown from 'icons/ChevronDown'
import IAddProgram from 'icons/PlaylistPlus'
import IAddVideo from 'icons/VideoPlus'
import IAddAudio from 'icons/VolumePlus'
import IClock from 'icons/Clock'
import IEdit from 'icons/Pencil'
import IEditPlaylist from 'icons/PlaylistEdit'
import IDelete from 'icons/Delete'

export default {
  name: 'AdminDashboardPage',
  mixins: [],
  components: {
    KActions,
    KMain,
    KObjects,
  },
  props: {},
  data() {
    return {
      icons: {
        'lock': ILock,
        'chevron-up': IChevronUp,
        'chevron-right': IChevronRight,
        'chevron-down': IChevronDown,
        'add-program': IAddProgram,
        'add-video': IAddVideo,
        'add-audio': IAddAudio,
        'clock': IClock,
        'edit': IEdit,
        'edit-playlist': IEditPlaylist,
        'delete': IDelete,
      },
      thisSections: null,
      thisObjects: null,
    }
  },
  created() {
    this.setSections( this.post )
    this.setObjects( this.post )
  },
  mounted() {},
  methods: {
    ...mapActions([ 'getModelCollection' ]),
    doAction( action, item ) {
    },
    setSections( post ) {
      if ( !post || !post.sections ) {
        this.thisSections = null
        return
      }
      const sections = []
      for ( const s of post.sections ) {
      }
      // this.thisSections = sections
    },
    setObjects( post ) {
      if ( !post) return
      if ( !post.objects && !post.model ) {
        this.thisObjects = null
        return
      }
      if ( this.post.model ) {
        this.thisObjects = null
        this.getModelCollection({
          model: this.post.model,
          ...( this.post.filter || {} )
        })
      }
    }
  },
  computed: {
    ...mapState([ 'post' ]),
    actions() {
      return ( this.post && this.post.actions ) || []
    },
    sections() {
      return this.thisSections || ( this.post && this.post.sections ) || []
    },
    objects() {
      return  this.thisObjects || ( this.post && this.post.objects ) || []
    },
  },
  watch: {
    post( post ) {
      if ( post ) {
        this.setSections( post )
        this.setObjects( post )
      }
    }
  }
}
</script>

<style lang="scss">
.admin-dashboard {
  section {
    > .header > .title {
      font-size: var(--s-lg);
    }
    > .body {
      > .item.denied {
        padding: var(--s-3q) var(--s-lg);
        --c-fg: grey;
      }
    }
  }
}
</style>
